import { render } from "./sub-menu-help.vue?vue&type=template&id=5e46b66f"
import script from "./sub-menu-help.vue?vue&type=script&lang=js"
export * from "./sub-menu-help.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ian/codebase/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__